import { privacyPolicyContent } from './privacyPolicyContent'

export const PrivacyPolicy = () => {
  return (
    <div id="policy" style={{ flex: 1, backgroundColor: '#FFF' }}>
      <pre>{privacyPolicyContent}</pre>
    </div>
  )
}
